<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
        <template v-slot:main>
            <head-utils title="Incluir nova Comissão"/>
            <breadcrumb
                    :items="[{label: 'Incluir nova Comissão', path: '/commission_payments'}, {label: 'Criar Nova Comissão', path: '/commission_payments/new'}]"/>

            <form @submit.prevent.stop="submit" novalidate>
                <ibox>
                    <template v-slot:title v-if="!$appUtils.isMobile()">
                        <h5>Dados do Comissão</h5>
                    </template>
                    <template v-slot:content>
                        <div class="container-fluid-grid">
                            <div class="form-row" v-if="$appUtils.isMobile() && brokerName !== ''">
                                <div class="col-12"><h3 class="t-c t-t-u">{{brokerName}}</h3></div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-2 col-12 form-group">
                                    <label for="finMovEditValue" class="required">Valor</label>
                                    <input type="text"
                                           id="finMovEditValue"
                                           required
                                           :class="{'is-invalid': errors.value}"
                                           readonly
                                           v-model="entity.value"
                                           v-money="{decimal: ',', thousands: '.', prefix: '', suffix: '', precision: 2}"
                                           :style="valueStyle"
                                           class="form-control-sm t-c form-control-plaintext f-w-700">
                                    <field-messages :errors="errors.value"/>
                                </div>
                                <div class="col-md-10 col-12 form-group">
                                    <label for="finMovEditValue" class="required">Contratos</label>
                                    <transition-group name="p-anim" tag="div" class="proposals-container" v-if="hasProposals">
                                        <span v-for="k in Object.keys(selectedProposals).sort((a,b) => b.id - a.id)" :key="k">
                                            {{selectedProposals[k].number}} <span @click="pickOrDetachProposal(selectedProposals[k])"><svg-icon icon="times"/></span>
                                        </span>
                                        <span v-if="Object.keys(selectedProposals).length > 1"
                                              :key="'clearProposals'"
                                              @click="() => {
                                              selectedProposals = {};
                                              calculateTotal();
                                              }"
                                              class="clear"><span><svg-icon icon="times"/></span></span>
                                    </transition-group>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-12 t-c">
                                    <div class="btn-group btn-group-sm" role="group" aria-label="Comandos de Pesquisa">
                                        <button type="button"
                                                @click="saveDraft"
                                                :disabled="!hasProposals"
                                                class="btn btn-sm btn-dark">Salvar Rascunho <svg-icon v-if="$appUtils.isDesktop()" icon="save"/></button>
                                        <button type="button"
                                                @click="openConfirmation"
                                                :disabled="!hasProposals"
                                                class="btn btn-sm btn-info">Solicitar Análise <svg-icon v-if="$appUtils.isDesktop()" icon="envelope"/></button>
                                        <button type="button"
                                                @click="callFinancialMovement"
                                                :disabled="!hasProposals"
                                                class="btn btn-sm btn-primary">Gerar Lançamento <svg-icon v-if="$appUtils.isDesktop()" icon="hand-holding-usd"/></button>
                                    </div>
                                    <hr v-if="$appUtils.isMobile()">
                                </div>
                            </div>
                            <div v-if="$appUtils.isDesktop() || filterMode">
                                <hr>
                                <div class="form-row">
                                    <div class="col-9 col-md-2 form-group">
                                        <label for="comPayEditBroker" class="required">Corretor</label>
                                        <select id="comPayEditBroker" class="form-control form-control-sm"
                                                :class="{'is-invalid': errors.broker_id}"
                                                :disabled="hasProposals"
                                                @change="submit()"
                                                v-model="search_params.broker_id">
                                            <option :value="null">[SELECIONE]</option>
                                            <option v-for="b in brokers"
                                                    :key="b.id"
                                                    :value="b.id"
                                                    :disabled="b.removed">{{`${b.name} ${b.last_name}`}}{{b.removed ? '(Desativado)' : ''}}</option>
                                        </select>
                                        <small class="c-theme" v-if="hasProposals">Para alterar, exclua os contratos selecionados</small>
                                        <field-messages :errors="errors.broker_id"/>
                                    </div>
                                    <div class="col-3 col-md-1 form-group">
                                        <label for="comPaySearchNumber">Número</label>
                                        <input id="comPaySearchNumber"
                                               maxlength="8"
                                               type="text"
                                               v-mask="'########'"
                                               class="form-control form-control-sm t-r"
                                               v-model="search_params.number"/>

                                    </div>
                                    <div class="col-6 col-md-3 form-group">
                                        <label for="comPaySearchSeller">Vendedor</label>
                                        <input id="comPaySearchSeller"
                                               type="text"
                                               class="form-control form-control-sm"
                                               v-model="search_params.seller_name"/>
                                    </div>
                                    <div class="col-6 col-md-3 form-group">
                                        <label for="comPaySearchBuyer">Comprador</label>
                                        <input id="comPaySearchBuyer"
                                               type="text"
                                               class="form-control form-control-sm"
                                               v-model="search_params.buyer_name"/>
                                    </div>
                                    <div class="col-12 col-md-3 form-group">
                                        <label for="comPaySearchProduct">Produto</label>
                                        <select id="comPaySearchProduct" class="form-control form-control-sm" v-model="search_params.product_id">
                                            <option :value="''">[SELECIONE]</option>
                                            <optgroup v-for="c in categories" :label="c.name">
                                                <option v-for="p in products"
                                                        v-if="p.product_category_id === c.id"
                                                        :key="p.id"
                                                        :value="p.id">{{p.name}}</option>
                                            </optgroup>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-6 col-md-2 form-group">
                                        <label for="comPaySearchBillingStart">Faturar entre</label>
                                        <div class="input-group input-group-sm">
                                            <input type="text"
                                                   id="comPaySearchBillingStart"
                                                   v-model="search_params.billing_at_start"
                                                   placeholder="DD/MM/AAAA"
                                                   v-mask="'##/##/####'"
                                                   v-flatpickr
                                                   class="form-control form-control-sm t-c plch-center n-m-r-right">
                                            <div class="input-group-append">
                                                <div class="input-group-text">
                                                    <svg-icon icon="calendar-alt"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-2 form-group">
                                        <label for="comPaySearchBillingEnd">&nbsp;</label>
                                        <div class="input-group input-group-sm">
                                            <input type="text"
                                                   id="comPaySearchBillingEnd"
                                                   v-model="search_params.billing_at_end"
                                                   placeholder="DD/MM/AAAA"
                                                   v-mask="'##/##/####'"
                                                   v-flatpickr
                                                   class="form-control form-control-sm t-c plch-center n-m-r-right">
                                            <div class="input-group-append">
                                                <div class="input-group-text">
                                                    <svg-icon icon="calendar-alt"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-6 col-md-2 form-group">
                                        <label for="comPaySearchCreatedStart">Criado entre</label>
                                        <div class="input-group input-group-sm">
                                            <input type="text"
                                                   id="comPaySearchCreatedStart"
                                                   v-model="search_params.created_start"
                                                   placeholder="DD/MM/AAAA"
                                                   v-mask="'##/##/####'"
                                                   v-flatpickr
                                                   class="form-control form-control-sm t-c plch-center n-m-r-right">
                                            <div class="input-group-append">
                                                <div class="input-group-text">
                                                    <svg-icon icon="calendar-alt"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-2 form-group">
                                        <label for="comPaySearchCreatedEnd">&nbsp;</label>
                                        <div class="input-group input-group-sm">
                                            <input type="text"
                                                   id="comPaySearchCreatedEnd"
                                                   v-model="search_params.created_end"
                                                   placeholder="DD/MM/AAAA"
                                                   v-mask="'##/##/####'"
                                                   v-flatpickr
                                                   class="form-control form-control-sm t-c plch-center n-m-r-right">
                                            <div class="input-group-append">
                                                <div class="input-group-text">
                                                    <svg-icon icon="calendar-alt"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-2 form-group">
                                        <label for="comPaySearchPaidStart">Pago entre</label>
                                        <div class="input-group input-group-sm">
                                            <input type="text"
                                                   id="comPaySearchPaidStart"
                                                   v-model="search_params.paid_start"
                                                   placeholder="DD/MM/AAAA"
                                                   v-mask="'##/##/####'"
                                                   v-flatpickr
                                                   class="form-control form-control-sm t-c plch-center n-m-r-right">
                                            <div class="input-group-append">
                                                <div class="input-group-text">
                                                    <svg-icon icon="calendar-alt"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-2 form-group">
                                        <label for="comPaySearchPaidEnd">&nbsp;</label>
                                        <div class="input-group input-group-sm">
                                            <input type="text"
                                                   id="comPaySearchPaidEnd"
                                                   v-model="search_params.paid_end"
                                                   placeholder="DD/MM/AAAA"
                                                   v-mask="'##/##/####'"
                                                   v-flatpickr
                                                   class="form-control form-control-sm t-c plch-center n-m-r-right">
                                            <div class="input-group-append">
                                                <div class="input-group-text">
                                                    <svg-icon icon="calendar-alt"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="$appUtils.isMobile() && !filterMode">
                            <div class="list-card" v-for="(p, idx) in search.entries">
                                <span class="idx f-w-700">#{{search.current_page * search.per_page - (search.per_page - idx - 1)}}</span>
                                <span class="dt t-c">DT {{p.created_at | formatDate}}</span>
                                <span class="fat t-c">FAT {{p.billing_date | formatDate}}</span>
                                <span class="nr t-r"><b>{{p.number}}</b></span>

                                <span class="seller ellipsis" :title="p.seller.name">{{p.seller.group.name}}</span>
                                <span class="buyer t-r ellipsis" :title="p.buyer.name">{{p.buyer.group.name}}</span>

                                <span class="neg-tlt">NEGOCIADO | EMBARCADO:</span>
                                <span class="neg-val t-c">{{p.quantity | formatNumber(3)}} | {{p.quantity_embedded ? $appUtils.formatNumber(p.quantity_embedded, 3) : 'N/D'}}</span>

                                <span class="agr f-w-700">AGRISOY</span>
                                <span class="agr-perc t-r f-w-700">{{p.value_or_percent_commission ? 'N/D' : $appUtils.formatMoney(p.percentage_commission)}}%</span>
                                <span class="agr-mon t-l f-w-700">R$ {{p.commission | formatMoney}}</span>

                                <span class="broker c-theme f-w-700">CORRETOR</span>
                                <span class="broker-perc t-r c-theme f-w-700">{{brokerCommission(p, false)}}%</span>
                                <span class="broker-mon t-l c-theme f-w-700">R$ {{brokerCommission(p, true)}}</span>

                                <div class="act">
                                    <button type="button"
                                            @click="pickOrDetachProposal(p)"
                                            class="btn btn-xs" :class="{'btn-theme-1': !selectedProposals[p.id],'btn-danger': selectedProposals[p.id]}">
                                        <svg-icon :icon="!selectedProposals[p.id] ? 'plus' : 'minus-circle'"/>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div v-if="$appUtils.isMobile()" class="t-c" ref='end_grid'>
                            <svg-icon v-if="searching && !filterMode" icon="sync" class="refresh load-more-crud"/>
                        </div>

                        <transition name="fab-menu" mode="out-in" v-if="$appUtils.isMobile()">
                            <Fab type="button" :key="'fabOpen'" v-if="!filterMode" icon="filter" color="red" :custom-style="{bottom: '50px'}" @click="filterMode = true"/>
                        </transition>
                    </template>
                    <template v-slot:footer>
                        <div class="container-fluid-grid">
                            <div class="row" v-if="$appUtils.isDesktop() || filterMode">
                                <div class="col t-r">
                                    <div class="btn-group btn-group-sm" role="group" aria-label="Comandos de Pesquisa">
                                        <button type="button" @click="reset" class="btn btn-secondary btn-sm"><svg-icon icon="sync"/> Limpar</button>
                                        <router-link to="/commission_payments" class="btn btn-dark btn-sm"><svg-icon icon="chevron-left"/> {{$appUtils.isMobile() ? 'Comissões' : 'Voltar Listagem'}}</router-link>
                                        <button type="button" @click="() => {
                                            entityDraft = {};
                                            showDraft = true;
                                        }" class="btn btn-warning btn-sm"><svg-icon icon="history"/> Rascunhos</button>
                                        <button type="button" @click="() => {
                                        submit();
                                        filterMode = false;
                                        }" :disabled="!search_params.broker_id" class="btn btn-theme-1 btn-sm"><svg-icon icon="search"/> Pesquisar</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="$appUtils.isDesktop()">
                                <div class="col-sm-12">
                                    <div v-if="search.entries.length > 0">
                                        <br/>
                                        <Pagination
                                                @paging="onChangePage"
                                                mode="callback"
                                                :page_size="search.per_page"
                                                :current_page="search.current_page"
                                                :total_entries="search.total_entries"/>


                                        <Loading :visible="searching"/>
                                        <table class="table table-hover table-striped table-sm table-bordered">
                                            <thead class="thead-dark thead-center">
                                            <tr>
                                                <th rowspan="2" style="width: 30px">#</th>
                                                <th rowspan="2">DATA</th>
                                                <th rowspan="2">NÚMERO</th>
                                                <th rowspan="2">VENDEDOR</th>
                                                <th rowspan="2">COMPRADOR</th>
                                                <th rowspan="2">FATURAR EM</th>
                                                <th rowspan="2">QTD NEG/EMB</th>
                                                <th colspan="2">AGRISOY</th>
                                                <th colspan="2">CORRETOR</th>
                                                <th rowspan="2" class="t-c v-m" style="width: 40px">
                                                    <button type="button"
                                                            v-if="search.entries.length > 0"
                                                            @click="addAllOrClear"
                                                            class="btn btn-xs" :class="{'btn-theme-1': !allEntriesChecked, 'btn-danger': allEntriesChecked}"><svg-icon :icon="allEntriesChecked ? 'times' : 'check'"/></button>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th>R$</th>
                                                <th>%</th>
                                                <th>R$</th>
                                                <th>%</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(p,idx) in search.entries" :key="p.id" v-if="!searching">
                                                <td class="t-c">{{search.current_page * search.per_page - (search.per_page - idx - 1)}}</td>
                                                <td class="t-c">{{p.created_at | formatDate}}</td>
                                                <td class="t-c"><router-link :to="`/proposals/${p.id}/edit`" class="link-theme">{{p.number}}</router-link></td>
                                                <td :title="p.seller.name">{{p.seller.group.name}}</td>
                                                <td :title="p.buyer.name">{{p.buyer.group.name}}</td>
                                                <td class="t-c" >{{p.billing_date | formatDate}}</td>
                                                <td class="t-c" >{{p.quantity | formatNumber(3)}} / {{p.quantity_embedded ? $appUtils.formatNumber(p.quantity_embedded, 3) : 'N/D'}}</td>
                                                <td class="t-r f-w-700" >{{p.commission | formatMoney}}</td>
                                                <td class="t-r f-w-700" >{{p.value_or_percent_commission ? 'N/D' : $appUtils.formatMoney(p.percentage_commission)}}</td>
                                                <td class="t-r f-w-700 c-theme" >{{brokerCommission(p, true)}}</td>
                                                <td class="t-r f-w-700 c-theme" >{{brokerCommission(p, false)}}</td>
                                                <td class="t-c">
                                                    <button type="button"
                                                            @click="pickOrDetachProposal(p)"
                                                            class="btn btn-xs" :class="{'btn-theme-1': !selectedProposals[p.id],'btn-danger': selectedProposals[p.id]}">
                                                        <svg-icon :icon="!selectedProposals[p.id] ? 'plus' : 'minus-circle'"/>
                                                    </button>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <Pagination
                                                v-if="search.entries.length > 0"
                                                @paging="onChangePage"
                                                mode="callback"
                                                :page_size="search.per_page"
                                                :current_page="search.current_page"
                                                :total_entries="search.total_entries"/>
                                    </div>
                                    <h3 v-else class="t-c"><br>Pelos critérios de consulta, não encontrei contratos...</h3>
                                </div>
                            </div>
                        </div>
                    </template>
                </ibox>
            </form>

            <ModalDrafts :show-modal="showDraft"
                         @onSelectDraft="onSelectDraft"
                         @onClose="showDraft = false"
                         :entity="entityDraft"/>

            <ModalConfirmationCommission
                    :show-modal="showConfirmation"
                    :data="entityConfirmation"
                    @onClose="showConfirmation = false"/>
        </template>
    </DefaultTmpl>
</template>

<script>
    import {mapGetters as mapGettersCrudNotifications, createNamespacedHelpers} from 'vuex'
    import DefaultTmpl from "../../templates/DefaultTmpl";
    import Pagination from "../../components/Pagination";
    import Loading from "../../components/particles/Loading";
    import Big from "big.js";
    import {EventBus} from "@/utils/EventBus";
    import dayjs from "dayjs";
    import ModalDrafts from "./ModalDrafts";
    import ModalConfirmationCommission from "./ModalConfirmationCommission";
    import Fab from "../../components/particles/Fab";
    const {mapGetters, mapActions} = createNamespacedHelpers('products');

    const CRUD_NOTIFICATIONS = 'crudNotifications'

    const defaultSearchParams = {
        broker_id: null,
        number: '',
        product_id: '',
        seller_name: '',
        buyer_name: '',
        billing_at_start: '',
        billing_at_end: '',
        created_start: '',
        created_end: '',
        paid_start: '',
        paid_end: '',
        page: 1
    };

    export default {
        name: "CommissionPaymentsEdit",
        components: {
            ModalConfirmationCommission,
            DefaultTmpl,
            Pagination,
            Loading,
            ModalDrafts,
            Fab
        },
        data() {
            return {
                brokers: [],
                errors: {},
                searching: false,
                endEntries: false,
                filterMode: false,
                selectedProposals: {},
                showDraft: false,
                showConfirmation: false,
                observerPagination: null,
                entity: {
                    value: '0,00'
                },
                entityDraft: {},
                entityConfirmation: {
                    broker: {
                        name: '',
                        email: '',
                        id: null
                    },
                    email_text: '',
                    proposals: []
                },
                search_params: {...defaultSearchParams},
                search: {
                    current_page: 1,
                    per_page: 0,
                    total_entries: 0,
                    entries: []
                }
            }
        },
        methods: {
            ...mapActions(['loadAll', 'loadCategories']),
            reset() {
                this.search_params = {...defaultSearchParams};
                this.selectedProposals = {};
                this.entity.value = '0,00';
                this.search = {
                    current_page: 1,
                    per_page: 0,
                    total_entries: 0,
                    entries: []
                };
            },
            submit() {
                this.search_params.page = 1;
                this.filter();

                this.createMobilePagination();
            },
            filter(isShowLoading = true) {
                const url = ['/v1/commission_payments/search_proposals?'];
                const params = new URLSearchParams(this.search_params);
                url.push(params.toString());
                this.searching = isShowLoading;
                this.$appHttp.get(url.join(''))
                    .then(({data}) => {
                        this.search = data;
                    })
                    .catch(console.error)
                    .finally(() => this.searching = false);
            },
            onChangePage(page) {
                this.search_params.page = page;
                this.filter();
            },
            brokerCommission(proposal, isValue) {
                let com = 0;

                if (isValue) {
                    if(proposal.broker_one.id === this.search_params.broker_id) com = proposal.broker_one_commission_value;
                    else if(proposal.broker_two.id === this.search_params.broker_id) com = proposal.broker_two_commission_value;
                    else com = proposal.broker_three_commission_value;
                } else {
                    if(proposal.broker_one.id === this.search_params.broker_id) com = proposal.broker_one_commission;
                    else if(proposal.broker_two.id === this.search_params.broker_id) com = proposal.broker_two_commission;
                    else com = proposal.broker_three_commission;
                }
                return this.$appUtils.formatMoney(com);
            },
            pickOrDetachProposal(p, isUpdate = false) {
                const isExists = !!this.selectedProposals[p.id]
                if (isUpdate) {
                  if (isExists) this.$set(this.selectedProposals, p.id, p)
                } else {
                  if (isExists) this.$delete(this.selectedProposals, p.id);
                  else this.$set(this.selectedProposals, p.id, p);
                }

                this.calculateTotal();
            },
            addAllOrClear() {
                let entries = this.search.entries
                if (!this.allEntriesChecked) entries = entries.filter(p => !this.selectedProposals[p.id])
                entries.forEach(p => this.pickOrDetachProposal(p));
            },
            calculateTotal() {
                let tot = new Big('0.0');
                Object.keys(this.selectedProposals).forEach(k => {
                    const p = this.selectedProposals[k];
                    let value = 0;
                    if(p.broker_one.id === this.search_params.broker_id) value = p.broker_one_commission_value;
                    else if (p.broker_two.id === this.search_params.broker_id) value = p.broker_two_commission_value;
                    else value = p.broker_three_commission_value;

                    tot = tot.plus(new Big(value));
                });

                this.entity.value = this.$appUtils.formatMoney(parseFloat(tot.toString()));
            },
            callFinancialMovement() {
                const brokerName = this.brokerName;
                const proposals = Object.keys(this.selectedProposals).map(k => this.selectedProposals[k]);

                const entity = {
                    value: this.entity.value,
                    emitted_at: dayjs().format('DD/MM/YYYY'),
                    scheduled_to: dayjs().format('DD/MM/YYYY'),
                    payment_type: 'bank_transfer',
                    movement_type: 'people',
                    in: false,
                    broker_id: this.search_params.broker_id,
                    identifier: `Pagamento comissão ${brokerName}`,
                    description: this.createDescription()
                };

                EventBus.showFinMov(() => {}, {
                    entity: entity,
                    proposals: proposals,
                    mode: 'commission'
                })
            },
            createDescription() {
                const arr = Object.keys(this.selectedProposals).map(k => this.selectedProposals[k]);
                const str = [];

                for (let i = 0; i < arr.length; i++) {
                    str.push('Pagamento de ',
                        this.brokerCommission(arr[i], false),
                        '% de comissão sobre o contrato nº ',
                        arr[i].number,
                        ', produto ',
                        arr[i].product.name,
                        ' sobre o valor de R$ ',
                        this.$appUtils.formatMoney(arr[i].commission),
                        ' totalizando comissão de R$ ',
                        this.brokerCommission(arr[i], true),
                        ';\n');
                }

                return str.join('');
            },
            saveDraft() {
                const brokerName = this.brokerName;
                this.$set(this.entityDraft, 'proposals', Object.keys(this.selectedProposals).map(k => this.selectedProposals[k]));
                this.$set(this.entityDraft, 'broker_id', this.search_params.broker_id);
                this.$set(this.entityDraft, 'broker_name', brokerName);
                this.$set(this.entityDraft, 'value', this.entity.value);
                this.showDraft = true;
            },
            onSelectDraft(draft) {
                this.search_params.broker_id = draft.broker_id;
                this.selectedProposals = {};
                draft.proposals.forEach(p => this.pickOrDetachProposal(p));
                this.submit();
                this.showDraft = false;
                this.filterMode = false;

                this.$snotify.success('Rascunho carregado com sucesso.', this.$appStorage.getUser().name);
            },
            openConfirmation() {
                this.entityConfirmation.broker.id = this.search_params.broker_id;
                const user = this.brokers.filter(b => b.id === this.search_params.broker_id)[0];
                this.entityConfirmation.broker.name = user.name;
                this.entityConfirmation.broker.email = user.email;
                this.entityConfirmation.proposals = Object.keys(this.selectedProposals).map(k => this.selectedProposals[k]);
                this.entityConfirmation.email_text = this.createDescription();

                this.showConfirmation = true;
            },
            createMobilePagination() {
                if (this.$appUtils.isMobile()) {
                    this.endEntries = false;
                    this.observerPagination = new IntersectionObserver(entries => {
                        entries.forEach(entry => {
                            this.endEntries = this.search.entries.length === this.search.total_entries;

                            if (entry.isIntersecting && !this.endEntries && !this.searching && this.search.total_entries > 0) {
                                const url = ['/v1/commission_payments/search_proposals?'];

                                let page = this.search_params.page || 0;
                                this.search_params.page = page + 1;
                                const params = new URLSearchParams(this.search_params);
                                url.push(params.toString());

                                this.searching = true;

                                this.$appHttp.get(url.join(''))
                                    .then(({data}) => {
                                        const newData = this.search.entries.concat(data.entries);
                                        delete data.entries;
                                        this.search = {...data, entries: newData};
                                    })
                                    .catch(console.error)
                                    .finally(() => this.searching = false);
                            }
                        })
                    }, {
                        root: null,
                        rootMargin: '200px'
                    });

                    this.observerPagination.observe(this.$refs.end_grid);
                }
            }
        },
        mounted() {
            this.loadCategories();
            this.loadAll();
            this.$appHttp.get('/v1/commission_payments/load_brokers')
                .then(({data}) => this.brokers = data)
                .catch(console.error);

            this.createMobilePagination();
        },
        computed: {
            ...mapGettersCrudNotifications([CRUD_NOTIFICATIONS]),
            ...mapGetters({products: 'all', categories: 'categories'}),
            allEntriesChecked() {
                const count = this.search.entries.length;

                if (count === 0) return false;

                return this.search.entries.filter(p => this.selectedProposals[p.id]).length === count
            },
            hasProposals() {
                return Object.keys(this.selectedProposals).length > 0
            },
            valueStyle() {
                return {
                    fontSize: this.$appUtils.isMobile() ? '3em' : '1em',
                    color: 'rgb(41, 56, 70)'
                }
            },
            brokerName() {
                if (this.search_params.broker_id)
                 return this.brokers.filter(b => b.id === this.search_params.broker_id)[0].name;

                return ''
            }
        },
        watch:  {
          [CRUD_NOTIFICATIONS]({proposals}) {
            if (proposals && proposals.object && this.search && this.search.entries) {
              const filter = this.search.entries.filter(p => p.id === proposals.object.id)

              if (filter.length > 0) this.filter(false);
            }
          },
          search: function ({entries}) {
            if (entries) {
              entries.forEach(e => this.pickOrDetachProposal(e, true))
            }
          }
        },
        destroyed() {
            if (this.observerPagination) {
                this.observerPagination.disconnect();
                this.observerPagination = null;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/variables";
    .proposals-container {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        border: 1px solid rgb(206, 212, 218);
        padding: 2px 2px 4px;
        border-radius: 5px;
        min-height: 29px;

        > span {
            background-color: $theme_color_one;
            color: #fff;
            display: inline-block;
            border-radius: .7em;
            padding-left: 10px;
            padding-right: 10px;
            font-size: .8em;
            margin-top: 2px;
            margin-right: 5px;

            span {
                display: inline-block;
                cursor: pointer;

                svg {
                    width: 1em;
                    height: 1em;
                    margin-top: -3px;
                }

                &:hover svg {
                    color: #000;
                }
            }

            &.clear {
                cursor: pointer;
                background-color: red;
                padding-left: 5px;
                padding-right: 5px;

                &:hover {
                    color: #000;
                }
            }
        }
    }

    .list-card {
        display: grid;
        width: 100%;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "idx dt fat nr"
        "seller seller buyer buyer"
        "neg-tlt neg-tlt neg-val neg-val"
        "agr agr agr-perc agr-mon"
        "broker broker broker-perc broker-mon"
        "act act act act";
        grid-gap: 5px;
        font-size: .8em;
        padding: 5px;

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }

        .idx {grid-area: idx}
        .dt {grid-area: dt}
        .fat {grid-area: fat}
        .nr {grid-area: nr}

        .seller {grid-area: seller}
        .buyer {grid-area: buyer}
        .neg-tlt {grid-area: neg-tlt}
        .neg-val {grid-area: neg-val}

        .agr {grid-area: agr}
        .agr-mon {grid-area: agr-mon}
        .agr-perc {grid-area: agr-perc}

        .broker {grid-area: broker}
        .broker-mon {grid-area: broker-mon}
        .broker-perc {grid-area: broker-perc}

        .act{
            grid-area: act;
            text-align: right;
            .btn:not(:last-child) {
                margin-right: 5px;
            }
        }
    }

    .p-anim-enter-active, .p-anim-leave-active {
        transition: all .3s ease-in-out;
    }
    .p-anim-enter, .p-anim-leave-to{
        opacity: 0;
        transform: scale(.1);
    }
</style>
